
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import AppLoading from "@/components/UI/AppLoading.vue";
import { required, minLength, minValue } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "AdminAddProduct",
  mixins: [validationMixin],
  components: { AppLoading },
  data() {
    return {
      chosenFile: "" as string | FormData,
      chosenFiles: "" as string | FormData,
      defaultImage: require("@/assets/img/default-product.jpg"),
      url: "https://webapi.vip-chef.ir/images/landing/",
    };
  },
  methods: {
    submitMainBanner() {
      store.dispatch("admin/createShopMainBanner", {
        image: this.chosenFile,
      });
    },
    uploadMainBannerImage(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        fileReader.onload = (event) => {
          store.dispatch("admin/updateShopMainBanner", event?.target?.result);
        };
        fileReader.readAsDataURL(file);

        // save choosed file
        let formData = new FormData();
        formData.append("image", file);
        this.chosenFile = formData;
      }
    },
    uploadImages(files: any): void {
      let formData = new FormData();

      for (let fileIndex in files) {
        const file = files[fileIndex];

        formData.append("images", file);
      }

      this.chosenFiles = formData;
    },

    banner(image: string) {
      if (image !== "") {
        return this.url + image;
      } else {
        return "";
      }
    },

    deleteBanner(id: string) {
      store.dispatch("admin/deleteShopMainBanner", id);
    },
  },
  computed: {
    mainBanners() {
      return store.state.admin.landing.shopMainBanners;
    },

    isLoading(): boolean {
      return store.state.app.loading;
    },
  },

  created() {
    store.dispatch("admin/getShopMainBanners");
  },
});
